export default {
  loading_menu: 'Chargement du menu...',
};
